import React from 'react';
import { Section } from './ui/Section';
export function ValueCalculator() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <Section data-id="element-319">
      <div className="max-w-2xl mx-auto" data-id="element-320">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-8 text-brand-title font-display" data-id="element-321">
          Dos tipos de instructoras.
        </h2>

        <div className="bg-white border border-brand-border rounded-2xl p-8 mb-8 shadow-card" data-id="element-322">
          <div className="space-y-6 text-center" data-id="element-323">
            <p className="text-lg text-brand-text" data-id="element-324">
              Las que siguen improvisando, cobrando lo mismo que hace tres años.
            </p>
            <p className="text-2xl text-brand-title font-bold font-display" data-id="element-325">
              Y las que deciden hoy.
            </p>
            <p className="text-brand-textMuted" data-id="element-326">
              Por 17,90€. Con garantía de 7 días. Acceso en 2 minutos.
            </p>
          </div>
        </div>

        <div className="text-center" data-id="element-327">
          <button onClick={scrollToPricing} className="bg-gradient-gold hover:bg-brand-ctaHover text-white font-bold text-xl md:text-2xl py-5 px-10 rounded-2xl transition-colors w-full md:w-auto tracking-wide shadow-gold-glow" data-id="element-328">
            🚀 QUIERO ENSEÑAR MEJOR DESDE HOY
          </button>
          <div className="mt-4 flex items-center justify-center gap-3 text-xs text-brand-textMuted flex-wrap" data-id="element-329">
            <span data-id="element-330">⚡ Acceso Inmediato</span>
            <span data-id="element-331">·</span>
            <span data-id="element-332">💳 Pago Único</span>
            <span data-id="element-333">·</span>
            <span data-id="element-334">🛡️ 7 Días</span>
            <span data-id="element-335">·</span>
            <span data-id="element-336">📱 PDF Móvil</span>
          </div>
        </div>
      </div>
    </Section>;
}